const SET_GROUPING_DATA = 'grouping.setGroupData';
const SET_GROUPING_AGG = 'grouping.setGroupAgg';
const SET_CURRENT_GROUPING = 'grouping.setCurrentGroup';
const SET_SECTION_VALUE = 'grouping.setSectionValue';
const SET_SECTION_VALUES = 'grouping.setSectionValues';
const SET_GROUPING_AGG_STATUS = 'grouping.setGroupAggStatus';
const AGG_NOT_LOADED = 'notLoaded';
const AGG_LOADING = 'loading';
const AGG_LOADED = 'loaded';
const AGG_ERROR = 'error';
const ALL_SECTION_VALUE = 'grouping.All';
const MISSING_SECTION_VALUE = 'grouping.Missing';
const AGG_REQUESTOR_PLUGIN_TYPE = 'Molten.GroupingAggRequestor';
const VALUE_LAYER_PLUGIN_TYPE = 'Molten.GroupingValueLayer';
const VALUE_SOURCE_PLUGIN_TYPE = 'Molten.GroupingValueSource';
const GOOGLE_VALUE_LAYER_PLUGIN_TYPE = 'Molten.google.GroupingValueLayer';
export default {
  SET_GROUPING_DATA,
  SET_GROUPING_AGG,
  SET_CURRENT_GROUPING,
  SET_SECTION_VALUE,
  SET_SECTION_VALUES,
  SET_GROUPING_AGG_STATUS,
  AGG_NOT_LOADED,
  AGG_LOADING,
  AGG_LOADED,
  AGG_ERROR,
  ALL_SECTION_VALUE,
  MISSING_SECTION_VALUE,
  AGG_REQUESTOR_PLUGIN_TYPE,
  VALUE_LAYER_PLUGIN_TYPE,
  VALUE_SOURCE_PLUGIN_TYPE,
  GOOGLE_VALUE_LAYER_PLUGIN_TYPE
};